<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <ApplicationQuestionTemplateForm
          ref="applicationQuestionTemplate"
          :applicationQuestionTemplate="applicationQuestionTemplate"
          @onSubmit="editTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-application-question-templates";
import { EDIT_APPLICATION_QUESTION_TEMPLATE } from "@/store/modules/organisations/organisation-application-question-templates/actions";
import ApplicationQuestionTemplateForm from "../ApplicationQuestionTemplateForm";
import { GET_CURRENT_ORGANISATION_ID } from "@/store/modules/auth/getters";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapGetters: mapAuthGetters } = createNamespacedHelpers(AUTH_NAMESPACE);

const { mapActions } = createNamespacedHelpers(
  ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean,
    applicationQuestionTemplate: Object
  },
  components: {
    PrimaryButton,
    DialogFull,
    ApplicationQuestionTemplateForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapAuthGetters({
      userOrganisationId: GET_CURRENT_ORGANISATION_ID
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Edit Application Question"
      };
    }
  },
  methods: {
    ...mapActions({
      editApplicationQuestionTemplate: EDIT_APPLICATION_QUESTION_TEMPLATE
    }),
    validateForm() {
      this.$refs.applicationQuestionTemplate.validateForm();
    },
    async editTemplate(templateData) {
      this.isLoading = true;
      await this.editApplicationQuestionTemplate({
        ...templateData,
        organisation: {
          id: this.userOrganisationId
        }
      });
      this.close();
      this.isLoading = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
